const HomeCareCreate = () =>
	import(
		/* webpackChunkName: "homecarecreate"*/ "@/views/HomeCare/Create/index.vue"
	);

const HomeCareList = () =>
	import(
		/* webpackChunkName: "homecarelist"*/ "@/views/HomeCareList/index.vue"
	);
const HomeCareView = () =>
	import(/* webpackChunkName: "homecareview"*/ "@/views/HomeCare/index.vue");
const HomeCareDashboard = () =>
	import(
		/* webpackChunkName: "homecaredashboard"*/ "@/views/HomeCare/Dashboard/index.vue"
	);
const HomeCareDetails = () =>
	import(
		/* webpackChunkName: "homecaredetails"*/ "@/views/HomeCare/Details/index.vue"
	);
const HomeCareSettings = () =>
	import(
		/* webpackChunkName: "homecaresettings"*/ "@/views/HomeCare/Settings/index.vue"
	);

const HomecareEditAllIn = () =>
	import(
		/* webpackChunkName: "homecareeditallIn"*/ "@/views/HomeCare/Edit/AllIn.vue"
	);
const HomecareEditIndividual = () =>
	import(
		/* webpackChunkName: "homecareeditindividual"*/ "@/views/HomeCare/Edit/Individual.vue"
	);

const HomeCarePreview = () =>
	import(
		/* webpackChunkName: "homecarepreview"*/ "@/views/HomeCarePreview/index.vue"
	);

export default [
	{
		path: "home-care/",
		name: "HomeCareList",
		component: HomeCareList,
		meta: {
			title: "DailyAdmin - Home care providers"
		}
	},
	{
		path: "home-care/create",
		name: "HomeCareCreate",
		component: HomeCareCreate,
		meta: {
			title: "DailyAdmin - Care provider create"
		}
	},
	{
		path: "home-care/:id",
		component: HomeCareView,
		children: [
			{
				path: "",
				name: "HomecareDashboard",
				component: HomeCareDashboard,
				meta: {
					title: "DailyAdmin - Care provider dashboard"
				}
			},
			{
				path: "details",
				name: "HomecareDetails",
				component: HomeCareDetails,
				meta: {
					title: "DailyAdmin - Care provider details"
				}
			},
			{
				path: "settings",
				name: "HomecareSettings",
				component: HomeCareSettings,
				meta: {
					title: "DailyAdmin - Care provider settings"
				}
			}
		]
	},
	{
		path: "home-care/:id/edit/",
		name: "HomecareEditAllIn",
		component: HomecareEditAllIn,
		meta: {
			title: "DailyAdmin - Care provider all edit"
		}
	},
	{
		path: "home-care/:id/edit/:form",
		name: "HomecareEditIndividual",
		component: HomecareEditIndividual,
		meta: {
			title: "DailyAdmin - Care provider edit"
		}
	},
	{
		path: "home-care/preview/:id",
		name: "HomeCarePreview",
		component: HomeCarePreview,
		meta: {
			title: "DailyAdmin - Care provider preview"
		}
	}
];
